import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './Trash.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { usePage } from '../../hooks/usePage';

import { menuChanged, selectMenu } from '../../features/infoSlice';
import { selectTrashOptions } from '../../features/trashSlice';
import { trashApiSlice, selectTotalTrashNum } from '../../services/trash';

import Container from '../../components/Container';
import TopArea from '../../components/TopArea';
import ListOption from '../../components/ListOption';
import List from '../../components/List';
import Details from '../../components/Details';
import { LIST, TRASH } from '../../constants';

export default function Trash() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menu = useAppSelector(selectMenu);
  const options = useAppSelector(selectTrashOptions);
  const { isDetailsOpened, isEditMode } = options;
  const { pageChanged } = usePage();
  const totalLen = useAppSelector(selectTotalTrashNum);

  useEffect(() => {
    dispatch(menuChanged('trash'));
    menu === 'trash' && dispatch(pageChanged(0));
  }, []);

  if (menu !== 'trash') return null;

  return (
    <Container isSubPage={true}>
      <TopArea title={TRASH} className="st_subpage" listLen={totalLen} />
      <div className={cx('content')}>
        <div className={cx('section')}>
          <h2 className="blind">
            {TRASH} {LIST}
          </h2>
          <ListOption />
          <div
            className={cx(
              'library_area',
              {
                'library--info-active': isDetailsOpened,
              },
              {
                'is--editing': isEditMode,
              }
            )}
          >
            <List />
            {isDetailsOpened && <Details />}
          </div>
        </div>
      </div>
    </Container>
  );
}
